import StatusLightSettings from "./StatusLightSettings";
import { getStatusLogicMode } from "../utils/statusLights";
﻿
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation } from 'react-router-dom';


import Datetime from "react-datetime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Form, Button, InputGroup, Alert } from '@themesberg/react-bootstrap';
/*import { SortableElement, SortableContainer } from 'react-sortable-hoc';*/
import { DndContext } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { restrictToParentElement } from '@dnd-kit/modifiers';
import { CSS } from '@dnd-kit/utilities';

import { ProjectDescriptionImageEditor } from './ProjectDescriptionImageEditor';

import geoNow from '../utils/geonow';



import moment from "moment-timezone";
import 'moment/locale/zh-tw';

const parseSmsRecipients = (value) => Array.from(new Set(
    (value ?? "")
        .split(/[,;\r\n]+/)
        .map(item => item.trim())
        .filter(Boolean)
));

const parseEmailRecipients = parseSmsRecipients;

const SMS_PROVIDERS = [
    { value: "0", name: "Infobip", label: "Infobip" },
    { value: "1", name: "TaiwanMitakeSite3", label: "台灣三竹（Site3）" },
    { value: "2", name: "TeamplusEvery8d", label: "Teamplus Every8D" }
];

const DEFAULT_GLOBAL_RATE_LIMITS = {
    lineNotifyCooldownMinutes: 30,
    lineNotifyMaxPerHour: 10,
    lineNotifyMaxPerDay: 50,
    lineNotifyMaxPerMonth: 200,
    smsNotifyCooldownMinutes: 30,
    smsNotifyMaxPerHour: 10,
    smsNotifyMaxPerDay: 50,
    smsNotifyMaxPerMonth: 1000,
    emailNotifyCooldownMinutes: 30,
    emailNotifyMaxPerHour: 10,
    emailNotifyMaxPerDay: 50,
    emailNotifyMaxPerMonth: 1000
};

const getProjectRateLimitValues = (project) => ({
    lineNotifyCooldownMinutes: project?.projectLineNotifyCooldownMinutes ?? "",
    lineNotifyMaxPerHour: project?.projectLineNotifyMaxPerHour ?? "",
    lineNotifyMaxPerDay: project?.projectLineNotifyMaxPerDay ?? "",
    lineNotifyMaxPerMonth: project?.projectLineNotifyMaxPerMonth ?? "",
    smsNotifyCooldownMinutes: project?.projectSmsNotifyCooldownMinutes ?? "",
    smsNotifyMaxPerHour: project?.projectSmsNotifyMaxPerHour ?? "",
    smsNotifyMaxPerDay: project?.projectSmsNotifyMaxPerDay ?? "",
    smsNotifyMaxPerMonth: project?.projectSmsNotifyMaxPerMonth ?? "",
    emailNotifyCooldownMinutes: project?.projectEmailNotifyCooldownMinutes ?? "",
    emailNotifyMaxPerHour: project?.projectEmailNotifyMaxPerHour ?? "",
    emailNotifyMaxPerDay: project?.projectEmailNotifyMaxPerDay ?? "",
    emailNotifyMaxPerMonth: project?.projectEmailNotifyMaxPerMonth ?? ""
});

const isRateLimitChannelInherited = (project, channel) => [
    project?.[`project${channel}NotifyCooldownMinutes`],
    project?.[`project${channel}NotifyMaxPerHour`],
    project?.[`project${channel}NotifyMaxPerDay`],
    project?.[`project${channel}NotifyMaxPerMonth`]
].every(value => value == null || value <= 0);

export const ProjectInfoForm = ({
    isCreation,
    isSuperUser,
    preData,
    submitHandler,
    onDescriptionImageChanged
}) => {
    //const [birthday, setBirthday] = useState("");

    


    const location = useLocation();
    const refTb_ListEQ_DataFolder = React.useRef(null);
    const refTb_LineNotifyDestination = React.useRef(null);
    const refTb_LineBotToken = React.useRef(null);

    const [, updateState] = React.useState();

    const [statusLogicMode, setStatusLogicMode] = useState(isCreation ? 0 : getStatusLogicMode(preData));
    const [alertActionDisplayKind, setAlertActionDisplayKind] = useState(isCreation ? 0 : preData?.projectAlertActionStatusDisplayKind ?? 0);
    const [projDisplayKind, setProjDisplayKind] = useState(isCreation ? '0' : preData?.projectStatusDisplayKind ?? '0');
    const [isTestingLine, setIsTestingLine] = useState(false);
    const [lineTestResult, setLineTestResult] = useState(null);
    const [lineBotProfileId, setLineBotProfileId] = useState(preData?.projectLineBotProfileId ?? "");
    const [lineBotProfiles, setLineBotProfiles] = useState([]);
    const [showLineBotProfileManager, setShowLineBotProfileManager] = useState(false);
    const [editingLineBotProfileId, setEditingLineBotProfileId] = useState(null);
    const [lineBotProfileName, setLineBotProfileName] = useState("");
    const [lineBotProfilePhone, setLineBotProfilePhone] = useState("");
    const [lineBotProfileToken, setLineBotProfileToken] = useState("");
    const [lineBotProfileResult, setLineBotProfileResult] = useState(null);
    const [isSavingLineBotProfile, setIsSavingLineBotProfile] = useState(false);
    const [smsProvider, setSmsProvider] = useState(
        preData?.projectSmsProvider == null ? "" : String(preData.projectSmsProvider)
    );
    const [smsSender, setSmsSender] = useState(preData?.projectSmsSender ?? "");
    const [inheritSmsSender, setInheritSmsSender] = useState(
        !preData?.projectSmsSender?.trim()
    );
    const [globalSmsDefaults, setGlobalSmsDefaults] = useState({
        defaultSmsProvider: 0,
        defaultSmsProviderName: "Infobip",
        defaultSmsSenders: {}
    });
    const [smsDefaultsError, setSmsDefaultsError] = useState(null);
    const [smsRecipients, setSmsRecipients] = useState(
        parseSmsRecipients(preData?.projectSmsRecipients)
    );
    const [newSmsRecipient, setNewSmsRecipient] = useState("");
    const [isTestingSms, setIsTestingSms] = useState(false);
    const [smsTestResult, setSmsTestResult] = useState(null);
    const [isQueryingSmsBalance, setIsQueryingSmsBalance] = useState(false);
    const [smsBalanceResult, setSmsBalanceResult] = useState(null);
    const [emailRecipients, setEmailRecipients] = useState(
        parseEmailRecipients(preData?.projectEmailRecipients)
    );
    const [newEmailRecipient, setNewEmailRecipient] = useState("");
    const [isTestingEmail, setIsTestingEmail] = useState(false);
    const [emailTestResult, setEmailTestResult] = useState(null);
    const [globalEmailDefaults, setGlobalEmailDefaults] = useState(null);
    const [emailDefaultsError, setEmailDefaultsError] = useState(null);
    const [globalRateLimits, setGlobalRateLimits] = useState(DEFAULT_GLOBAL_RATE_LIMITS);
    const [globalRateLimitDraft, setGlobalRateLimitDraft] = useState(DEFAULT_GLOBAL_RATE_LIMITS);
    const [globalRateLimitResult, setGlobalRateLimitResult] = useState(null);
    const [showGlobalRateLimitManager, setShowGlobalRateLimitManager] = useState(false);
    const [isSavingGlobalRateLimits, setIsSavingGlobalRateLimits] = useState(false);
    const [projectRateLimits, setProjectRateLimits] = useState(getProjectRateLimitValues(preData));
    const [inheritLineRateLimits, setInheritLineRateLimits] = useState(isRateLimitChannelInherited(preData, "Line"));
    const [inheritSmsRateLimits, setInheritSmsRateLimits] = useState(isRateLimitChannelInherited(preData, "Sms"));
    const [inheritEmailRateLimits, setInheritEmailRateLimits] = useState(isRateLimitChannelInherited(preData, "Email"));
    const [lineRateLimitProfileId, setLineRateLimitProfileId] = useState(preData?.projectLineNotifyRateLimitProfileId ?? "");
    const [smsRateLimitProfileId, setSmsRateLimitProfileId] = useState(preData?.projectSmsNotifyRateLimitProfileId ?? "");
    const [emailRateLimitProfileId, setEmailRateLimitProfileId] = useState(preData?.projectEmailNotifyRateLimitProfileId ?? "");
    const [rateLimitProfiles, setRateLimitProfiles] = useState([]);
    const [editingRateLimitProfileId, setEditingRateLimitProfileId] = useState(null);
    const [isSavingRateLimitProfile, setIsSavingRateLimitProfile] = useState(false);
    const [rateLimitProfileDraft, setRateLimitProfileDraft] = useState({
        name: "", channel: "0", lineBotProfileId: "", smsProvider: "", cooldownMinutes: 30,
        maxPerHour: 10, maxPerDay: 50, maxPerMonth: 200
    });
    useEffect(() => {
        if (preData && preData !== null) {
            setProjDisplayKind(preData?.projectStatusDisplayKind ?? '0');
            setStatusLogicMode(getStatusLogicMode(preData));
            setAlertActionDisplayKind(preData?.projectAlertActionStatusDisplayKind ?? 0);
            let preCustomDataFieldOrder = convertOrderStringToOrderList(preData?.projectCustomDataFieldOrder);
            setCustomFieldOrderList(preCustomDataFieldOrder);
            setSmsRecipients(parseSmsRecipients(preData?.projectSmsRecipients));
            setSmsProvider(preData?.projectSmsProvider == null ? "" : String(preData.projectSmsProvider));
            setSmsSender(preData?.projectSmsSender ?? "");
            setInheritSmsSender(!preData?.projectSmsSender?.trim());
            setNewSmsRecipient("");
            setEmailRecipients(parseEmailRecipients(preData?.projectEmailRecipients));
            setNewEmailRecipient("");
            setLineBotProfileId(preData?.projectLineBotProfileId ?? "");
            setProjectRateLimits(getProjectRateLimitValues(preData));
            setInheritLineRateLimits(isRateLimitChannelInherited(preData, "Line"));
            setInheritSmsRateLimits(isRateLimitChannelInherited(preData, "Sms"));
            setInheritEmailRateLimits(isRateLimitChannelInherited(preData, "Email"));
            setLineRateLimitProfileId(preData?.projectLineNotifyRateLimitProfileId ?? "");
            setSmsRateLimitProfileId(preData?.projectSmsNotifyRateLimitProfileId ?? "");
            setEmailRateLimitProfileId(preData?.projectEmailNotifyRateLimitProfileId ?? "");
        }
    }, [preData]);

    useEffect(() => {
        if (!isSuperUser) {
            return undefined;
        }

        let isCancelled = false;
        setSmsDefaultsError(null);
        geoNow.api.project.getSmsDefaults(geoNow.getToken())
            .then(result => {
                if (isCancelled) {
                    return;
                }
                if (result?.status !== 1 || !result?.message) {
                    throw new Error(result?.message ?? "無法讀取 GNS 全域設定。");
                }
                setGlobalSmsDefaults(result.message);
            })
            .catch(error => {
                if (!isCancelled) {
                    setSmsDefaultsError(error.message ?? "無法讀取 GNS 全域設定。");
                }
            });

        return () => {
            isCancelled = true;
        };
    }, [isSuperUser]);

    useEffect(() => {
        if (!isSuperUser) {
            return undefined;
        }

        let isCancelled = false;
        setGlobalRateLimitResult(null);
        Promise.all([
            geoNow.api.valueNotifyRateLimitSettings.get(geoNow.getToken()),
            geoNow.api.valueNotifyRateLimitProfile.list(geoNow.getToken())
        ])
            .then(([result, profilesResult]) => {
                if (isCancelled) {
                    return;
                }
                if (result?.status !== 1 || !result?.message) {
                    throw new Error(result?.message ?? "無法讀取全域防濫發設定。");
                }
                setGlobalRateLimits(result.message);
                setGlobalRateLimitDraft(result.message);
                if (profilesResult?.status !== 1) {
                    throw new Error(profilesResult?.message ?? "無法讀取防濫發 Profile。");
                }
                setRateLimitProfiles(profilesResult.message ?? []);
            })
            .catch(error => {
                if (!isCancelled) {
                    setGlobalRateLimitResult({ variant: "danger", message: error.message ?? "無法讀取全域防濫發設定。" });
                }
            });

        return () => {
            isCancelled = true;
        };
    }, [isSuperUser]);

    useEffect(() => {
        if (!isSuperUser) {
            return undefined;
        }

        let isCancelled = false;
        geoNow.api.lineBotProfile.list(geoNow.getToken())
            .then(result => {
                if (isCancelled) {
                    return;
                }
                if (result?.status !== 1) {
                    throw new Error(result?.message ?? "無法讀取 LINE Bot 設定檔。");
                }
                setLineBotProfiles(result.message ?? []);
            })
            .catch(error => {
                if (!isCancelled) {
                    setLineBotProfileResult({ variant: "danger", message: error.message ?? "無法讀取 LINE Bot 設定檔。" });
                }
            });

        return () => {
            isCancelled = true;
        };
    }, [isSuperUser]);

    useEffect(() => {
        if (!isSuperUser) {
            return undefined;
        }

        let isCancelled = false;
        setEmailDefaultsError(null);
        geoNow.api.project.getEmailDefaults(geoNow.getToken())
            .then(result => {
                if (isCancelled) {
                    return;
                }
                if (result?.status !== 1 || !result?.message) {
                    throw new Error(result?.message ?? "無法讀取全域 SMTP 設定。");
                }
                setGlobalEmailDefaults(result.message);
            })
            .catch(error => {
                if (!isCancelled) {
                    setEmailDefaultsError(error.message ?? "無法讀取全域 SMTP 設定。");
                }
            });

        return () => {
            isCancelled = true;
        };
    }, [isSuperUser]);

    const effectiveSmsProvider = smsProvider === ""
        ? String(globalSmsDefaults.defaultSmsProvider ?? 0)
        : smsProvider;
    const effectiveSmsProviderInfo = SMS_PROVIDERS.find(item => item.value === effectiveSmsProvider)
        ?? SMS_PROVIDERS[0];
    const globalSmsSender = globalSmsDefaults.defaultSmsSenders?.[effectiveSmsProviderInfo.name] ?? "";
    const effectiveSmsSender = inheritSmsSender ? globalSmsSender : smsSender.trim();

    useEffect(() => {
        if (lineRateLimitProfileId) {
            const profile = rateLimitProfiles.find(item => item.id === lineRateLimitProfileId);
            if (profile && profile.lineBotProfileId && profile.lineBotProfileId !== lineBotProfileId) {
                setLineRateLimitProfileId("");
            }
        }
        if (smsRateLimitProfileId) {
            const profile = rateLimitProfiles.find(item => item.id === smsRateLimitProfileId);
            if (profile && profile.smsProvider != null && String(profile.smsProvider) !== effectiveSmsProvider) {
                setSmsRateLimitProfileId("");
            }
        }
    }, [lineBotProfileId, lineRateLimitProfileId, smsRateLimitProfileId, effectiveSmsProvider, rateLimitProfiles]);


    const forceUpdate = React.useCallback(() => updateState({}), []);

    const canEdit = isCreation ? true : (preData?.isProjectAdmin ?? false);

    const getLineBotProfileLabel = (profile) => {
        const identifiers = [profile.name, profile.phoneNumber].filter(Boolean);
        return identifiers.length > 0 ? identifiers.join(" / ") : `未命名（${profile.id.slice(0, 8)}）`;
    };

    const setProjectRateLimit = (name, value) => {
        setProjectRateLimits(current => ({ ...current, [name]: value }));
    };

    const setChannelRateLimitInheritance = (channel, inherit) => {
        const setInheritance = channel === "line"
            ? setInheritLineRateLimits
            : channel === "sms"
                ? setInheritSmsRateLimits
                : setInheritEmailRateLimits;
        setInheritance(inherit);
        if (!inherit) {
            const prefix = `${channel}Notify`;
            setProjectRateLimits(current => ({
                ...current,
                [`${prefix}CooldownMinutes`]: current[`${prefix}CooldownMinutes`] || globalRateLimits[`${prefix}CooldownMinutes`],
                [`${prefix}MaxPerHour`]: current[`${prefix}MaxPerHour`] || globalRateLimits[`${prefix}MaxPerHour`],
                [`${prefix}MaxPerDay`]: current[`${prefix}MaxPerDay`] || globalRateLimits[`${prefix}MaxPerDay`],
                [`${prefix}MaxPerMonth`]: current[`${prefix}MaxPerMonth`] || globalRateLimits[`${prefix}MaxPerMonth`]
            }));
        }
    };

    const setRateLimitSource = (channel, value) => {
        const setProfileId = channel === "line"
            ? setLineRateLimitProfileId
            : channel === "sms"
                ? setSmsRateLimitProfileId
                : setEmailRateLimitProfileId;
        if (value === "override") {
            setProfileId("");
            setChannelRateLimitInheritance(channel, false);
        } else {
            setProfileId(value === "global" ? "" : value);
            setChannelRateLimitInheritance(channel, true);
        }
    };

    const saveGlobalRateLimits = async () => {
        const payload = Object.fromEntries(
            Object.keys(DEFAULT_GLOBAL_RATE_LIMITS).map(key => [key, Number(globalRateLimitDraft[key])])
        );
        if (Object.values(payload).some(value => !Number.isInteger(value) || value <= 0)) {
            setGlobalRateLimitResult({ variant: "danger", message: "所有全域限制都必須是大於 0 的整數。" });
            return;
        }
        if (payload.lineNotifyMaxPerDay < payload.lineNotifyMaxPerHour ||
            payload.smsNotifyMaxPerDay < payload.smsNotifyMaxPerHour ||
            payload.emailNotifyMaxPerDay < payload.emailNotifyMaxPerHour) {
            setGlobalRateLimitResult({ variant: "danger", message: "各通道的每日上限不得小於每小時上限。" });
            return;
        }
        if (payload.lineNotifyMaxPerMonth < payload.lineNotifyMaxPerDay ||
            payload.smsNotifyMaxPerMonth < payload.smsNotifyMaxPerDay ||
            payload.emailNotifyMaxPerMonth < payload.emailNotifyMaxPerDay) {
            setGlobalRateLimitResult({ variant: "danger", message: "各通道的每月上限不得小於每日上限。" });
            return;
        }

        setIsSavingGlobalRateLimits(true);
        setGlobalRateLimitResult(null);
        try {
            const result = await geoNow.api.valueNotifyRateLimitSettings.update(geoNow.getToken(), payload);
            if (result?.status !== 1 || !result?.message) {
                throw new Error(result?.message ?? "全域防濫發設定儲存失敗。");
            }
            setGlobalRateLimits(result.message);
            setGlobalRateLimitDraft(result.message);
            setGlobalRateLimitResult({ variant: "success", message: "全域防濫發設定已儲存；繼承的專案會自動套用。" });
        } catch (error) {
            setGlobalRateLimitResult({ variant: "danger", message: error.message ?? "全域防濫發設定儲存失敗。" });
        } finally {
            setIsSavingGlobalRateLimits(false);
        }
    };

    const resetRateLimitProfileDraft = () => {
        setEditingRateLimitProfileId(null);
        setRateLimitProfileDraft({ name: "", channel: "0", lineBotProfileId: "", smsProvider: "", cooldownMinutes: 30, maxPerHour: 10, maxPerDay: 50, maxPerMonth: 200 });
    };

    const saveRateLimitProfile = async () => {
        const payload = {
            name: rateLimitProfileDraft.name.trim(),
            channel: Number(rateLimitProfileDraft.channel),
            lineBotProfileId: rateLimitProfileDraft.channel === "0" ? rateLimitProfileDraft.lineBotProfileId || null : null,
            smsProvider: rateLimitProfileDraft.channel === "1" && rateLimitProfileDraft.smsProvider !== "" ? Number(rateLimitProfileDraft.smsProvider) : null,
            cooldownMinutes: Number(rateLimitProfileDraft.cooldownMinutes),
            maxPerHour: Number(rateLimitProfileDraft.maxPerHour),
            maxPerDay: Number(rateLimitProfileDraft.maxPerDay),
            maxPerMonth: Number(rateLimitProfileDraft.maxPerMonth)
        };
        if (!payload.name || [payload.cooldownMinutes, payload.maxPerHour, payload.maxPerDay, payload.maxPerMonth].some(value => !Number.isInteger(value) || value <= 0)) {
            setGlobalRateLimitResult({ variant: "danger", message: "Profile 名稱與四項正整數限制都必須填寫。" });
            return;
        }
        setIsSavingRateLimitProfile(true);
        try {
            const result = editingRateLimitProfileId
                ? await geoNow.api.valueNotifyRateLimitProfile.update(geoNow.getToken(), editingRateLimitProfileId, payload)
                : await geoNow.api.valueNotifyRateLimitProfile.add(geoNow.getToken(), payload);
            if (result?.status !== 1) throw new Error(result?.message ?? "防濫發 Profile 儲存失敗。");
            const listResult = await geoNow.api.valueNotifyRateLimitProfile.list(geoNow.getToken());
            setRateLimitProfiles(listResult?.message ?? []);
            resetRateLimitProfileDraft();
            setGlobalRateLimitResult({ variant: "success", message: "防濫發 Profile 已儲存。" });
        } catch (error) {
            setGlobalRateLimitResult({ variant: "danger", message: error.message ?? "防濫發 Profile 儲存失敗。" });
        } finally {
            setIsSavingRateLimitProfile(false);
        }
    };

    const editRateLimitProfile = (profile) => {
        setEditingRateLimitProfileId(profile.id);
        setRateLimitProfileDraft({
            name: profile.name, channel: String(profile.channel), lineBotProfileId: profile.lineBotProfileId ?? "",
            smsProvider: profile.smsProvider == null ? "" : String(profile.smsProvider), cooldownMinutes: profile.cooldownMinutes,
            maxPerHour: profile.maxPerHour, maxPerDay: profile.maxPerDay, maxPerMonth: profile.maxPerMonth
        });
    };

    const deleteRateLimitProfile = async (profile) => {
        if (!window.confirm(`確定刪除防濫發 Profile「${profile.name}」？`)) return;
        try {
            const result = await geoNow.api.valueNotifyRateLimitProfile.delete(geoNow.getToken(), profile.id);
            if (result?.status !== 1) throw new Error(result?.message ?? "刪除失敗。");
            setRateLimitProfiles(current => current.filter(item => item.id !== profile.id));
            setGlobalRateLimitResult({ variant: "success", message: "防濫發 Profile 已刪除。" });
        } catch (error) {
            setGlobalRateLimitResult({ variant: "danger", message: error.message ?? "刪除失敗。" });
        }
    };

    const resetLineBotProfileEditor = () => {
        setEditingLineBotProfileId(null);
        setLineBotProfileName("");
        setLineBotProfilePhone("");
        setLineBotProfileToken("");
    };

    const editLineBotProfile = (profile) => {
        setEditingLineBotProfileId(profile.id);
        setLineBotProfileName(profile.name ?? "");
        setLineBotProfilePhone(profile.phoneNumber ?? "");
        setLineBotProfileToken("");
        setLineBotProfileResult(null);
    };

    const saveLineBotProfile = async () => {
        if (isSavingLineBotProfile || (!editingLineBotProfileId && !lineBotProfileToken.trim())) {
            return;
        }

        setIsSavingLineBotProfile(true);
        setLineBotProfileResult(null);
        try {
            const payload = {
                name: lineBotProfileName.trim() || null,
                phoneNumber: lineBotProfilePhone.trim() || null,
                accessToken: lineBotProfileToken.trim() || null
            };
            const result = editingLineBotProfileId
                ? await geoNow.api.lineBotProfile.update(geoNow.getToken(), editingLineBotProfileId, payload)
                : await geoNow.api.lineBotProfile.add(geoNow.getToken(), payload);
            if (result?.status !== 1) {
                throw new Error(result?.message ?? "LINE Bot 設定檔儲存失敗。");
            }

            const savedProfile = result.message;
            setLineBotProfiles(current => {
                const exists = current.some(profile => profile.id === savedProfile.id);
                const next = exists
                    ? current.map(profile => profile.id === savedProfile.id ? savedProfile : profile)
                    : [...current, savedProfile];
                return next.sort((left, right) => getLineBotProfileLabel(left).localeCompare(getLineBotProfileLabel(right), "zh-Hant"));
            });
            setLineBotProfileResult({ variant: "success", message: editingLineBotProfileId ? "LINE Bot 設定檔已更新。" : "LINE Bot 設定檔已建立。" });
            resetLineBotProfileEditor();
        } catch (error) {
            setLineBotProfileResult({ variant: "danger", message: error.message ?? "LINE Bot 設定檔儲存失敗。" });
        } finally {
            setIsSavingLineBotProfile(false);
        }
    };

    const deleteLineBotProfile = async (profile) => {
        if (!window.confirm(`確定刪除 LINE Bot 設定檔「${getLineBotProfileLabel(profile)}」？`)) {
            return;
        }

        setLineBotProfileResult(null);
        try {
            const result = await geoNow.api.lineBotProfile.delete(geoNow.getToken(), profile.id);
            if (result?.status !== 1) {
                throw new Error(result?.message ?? "LINE Bot 設定檔刪除失敗。");
            }
            setLineBotProfiles(current => current.filter(item => item.id !== profile.id));
            if (lineBotProfileId === profile.id) {
                setLineBotProfileId("");
            }
            setLineBotProfileResult({ variant: "success", message: "LINE Bot 設定檔已刪除。" });
            if (editingLineBotProfileId === profile.id) {
                resetLineBotProfileEditor();
            }
        } catch (error) {
            setLineBotProfileResult({ variant: "danger", message: error.message ?? "LINE Bot 設定檔刪除失敗。" });
        }
    };

    const testLineMessage = async (e) => {
        e.preventDefault();
        if (isCreation || !preData?.projectId || isTestingLine) {
            return;
        }

        setIsTestingLine(true);
        setLineTestResult(null);
        try {
            const result = await geoNow.api.project.testLineMessage(
                geoNow.getToken(),
                preData.projectId,
                {
                    lineNotifyDestination: refTb_LineNotifyDestination.current?.value?.trim() || null,
                    lineBotToken: refTb_LineBotToken.current?.value?.trim() || null,
                    lineBotProfileId: lineBotProfileId || null,
                    useExplicitLineBotToken: !lineBotProfileId
                }
            );
            if (!result || result.status !== 1) {
                throw new Error(result?.message ?? "LINE 測試訊息發送失敗。");
            }
            setLineTestResult({ variant: "success", message: result.message });
        } catch (error) {
            setLineTestResult({
                variant: "danger",
                message: error.message ?? "LINE 測試訊息發送失敗。"
            });
        } finally {
            setIsTestingLine(false);
        }
    };

    const collectSmsRecipients = () => Array.from(new Set([
        ...smsRecipients,
        ...parseSmsRecipients(newSmsRecipient)
    ]));

    const addSmsRecipient = () => {
        const recipients = collectSmsRecipients();
        setSmsRecipients(recipients);
        setNewSmsRecipient("");
    };

    const removeSmsRecipient = (recipient) => {
        setSmsRecipients(current => current.filter(item => item !== recipient));
    };

    const testSmsMessage = async (e) => {
        e.preventDefault();
        if (isCreation || !preData?.projectId || isTestingSms) {
            return;
        }

        setIsTestingSms(true);
        setSmsTestResult(null);
        try {
            const result = await geoNow.api.project.testSmsMessage(
                geoNow.getToken(),
                preData.projectId,
                {
                    smsProvider: smsProvider === "" ? null : Number(smsProvider),
                    inheritSmsProvider: smsProvider === "",
                    smsSender: inheritSmsSender ? null : smsSender.trim() || null,
                    inheritSmsSender,
                    smsRecipients: collectSmsRecipients()
                }
            );
            const details = result?.message ?? null;
            setSmsTestResult({
                variant: result?.status === 1 ? "success" : "danger",
                message: details?.summary ?? "GNS 測試簡訊發送失敗。",
                details,
                showDetails: false
            });
        } catch (error) {
            setSmsTestResult({
                variant: "danger",
                message: error.message ?? "GNS 測試簡訊發送失敗。",
                details: {
                    exceptionType: error.name,
                    exceptionMessage: error.message,
                    exceptionDetail: error.stack
                },
                showDetails: false
            });
        } finally {
            setIsTestingSms(false);
        }
    };

    const querySmsBalance = async (e) => {
        e.preventDefault();
        if (isQueryingSmsBalance) {
            return;
        }

        setIsQueryingSmsBalance(true);
        setSmsBalanceResult(null);
        try {
            const result = await geoNow.api.project.querySmsBalance(
                geoNow.getToken(),
                { smsProvider: smsProvider === "" ? null : Number(smsProvider) }
            );
            const details = result?.message ?? null;
            const balance = details?.data;
            const freeMessages = balance?.freeMessages == null
                ? ""
                : `，免費簡訊 ${balance.freeMessages} 則`;
            setSmsBalanceResult({
                variant: result?.status === 1 ? "success" : "danger",
                message: result?.status === 1
                    ? `餘額：${balance?.balance ?? 0} ${balance?.currency ?? ""}${freeMessages}`
                    : details?.summary ?? "GNS 餘額查詢失敗。",
                details,
                showDetails: false
            });
        } catch (error) {
            setSmsBalanceResult({
                variant: "danger",
                message: error.message ?? "GNS 餘額查詢失敗。",
                details: {
                    exceptionType: error.name,
                    exceptionMessage: error.message,
                    exceptionDetail: error.stack
                },
                showDetails: false
            });
        } finally {
            setIsQueryingSmsBalance(false);
        }
    };

    const collectEmailRecipients = () => Array.from(new Set([
        ...emailRecipients,
        ...parseEmailRecipients(newEmailRecipient)
    ]));

    const addEmailRecipient = () => {
        setEmailRecipients(collectEmailRecipients());
        setNewEmailRecipient("");
    };

    const removeEmailRecipient = (recipient) => {
        setEmailRecipients(current => current.filter(item => item !== recipient));
    };

    const testEmailMessage = async (e) => {
        e.preventDefault();
        if (isCreation || !preData?.projectId || isTestingEmail) {
            return;
        }

        setIsTestingEmail(true);
        setEmailTestResult(null);
        try {
            const result = await geoNow.api.project.testEmailMessage(
                geoNow.getToken(),
                preData.projectId,
                { emailRecipients: collectEmailRecipients() }
            );
            const details = result?.message ?? null;
            setEmailTestResult({
                variant: result?.status === 1 ? "success" : "danger",
                message: details?.summary ?? "SMTP 測試信寄送失敗。",
                details,
                showDetails: false
            });
        } catch (error) {
            setEmailTestResult({
                variant: "danger",
                message: error.message ?? "SMTP 測試信寄送失敗。",
                details: {
                    exceptionType: error.name,
                    exceptionMessage: error.message,
                    exceptionDetail: error.stack
                },
                showDetails: false
            });
        } finally {
            setIsTestingEmail(false);
        }
    };

    const getMoveIndex = (array, dragItem) => {
        const { active, over } = dragItem;
        let activeIndex = 0;
        let overIndex = 0;
        try {
            // 遍历数组，查找出active和over的index
            array.forEach((item, index) => {
                if (active.id === item.key) {
                    activeIndex = index;
                }
                if (over.id === item.key) {
                    overIndex = index;
                }
            });
        } catch (error) {
            overIndex = activeIndex; // 如果有问题，则复位
        }
        return { activeIndex, overIndex };
    };
    function handleDataListChange(newDataList)
    {
        let newStr = convertOrderListToOrderString(newDataList);
        console.log(`[New CustomDataField Order]\n ${newStr}`)
        customFieldOrderString = newStr;
    }
    const defaultCustomFieldOrderList = geoNow.stateHelper.project.customDataField.getDefaultOrderList();
    //const defaultCustomFieldOrderList = [
    //    { key: '#', isChecked: true, title: '編號' },
    //    { key: 'pointNo', isChecked: true, title: '儀器名稱' },
    //    { key: 'value', isChecked: true, title: '物理量' },
    //    { key: 'initial', isChecked: true, title: '初值' },
    //    { key: 'alert', isChecked: true, title: '警戒值' },
    //    { key: 'alarm1', isChecked: true, title: '警示1' },
    //    { key: 'alarm2', isChecked: true, title: '警示2' },
    //    { key: 'action', isChecked: true, title: '行動值' },
    //    { key: 'note', isChecked: true, title: '備註' },
    //];
    const [customFieldOrderList, setCustomFieldOrderList] = useState(defaultCustomFieldOrderList);
    var customFieldOrderString = convertOrderListToOrderString(customFieldOrderList);
    function convertOrderListToOrderString(orderList) {
        // orderList: [{key: "point
        // No", isChecked: true}, ...]
        // if isChecked, then it is shown
        // if not, then it is not shown
        // if all items are shown, then return null or empty string
        // if some items are shown, then return the orderString
        // comment ends
        const orderArray = orderList.filter(item => item.isChecked).map(item => item.key);
        if (orderArray.length === 0) {
            return null;
        }
        // if order is the same as default and length are the same, then return null
        if (orderArray.length === defaultCustomFieldOrderList.length && orderArray.every((value, index) => value === defaultCustomFieldOrderList[index].key)) {
            return null;
        }
        return orderArray.join(",");
    }
    function convertOrderStringToOrderList(orderString) {
        // orderString: "pointNo,initial,alert,alarm1,alarm2,action,note"
        // if there are missing items, then it means that the missing items are not shown so checkbox should be unchecked
        // if orderString is null or empty, then it means that all items are shown (default)
        // respect the order of the orderString
        // comment stops
        if (orderString === null || orderString === "") {
            return defaultCustomFieldOrderList;
        }
        else {
            
            const orderArray = orderString.split(",");
            const newOrderList = defaultCustomFieldOrderList.map(item => {
                return {
                    ...item,
                    isChecked: orderArray.includes(item.key)
                };
            });

            // Sort the list based on the order in 'orderArray'
            newOrderList.sort((a, b) => {
                if (!a.isChecked && b.isChecked) {
                    return 1;
                }
                if (a.isChecked && !b.isChecked) {
                    return -1;
                }
                return orderArray.indexOf(a.key) - orderArray.indexOf(b.key);
            });

            return newOrderList;
            
        }


    }

    function DndSortComponent(props) {
        

        useEffect(() => {
            props.onChange(customFieldOrderList);// 这里写你自己对父组件传值的方式
        }, []);

        // 拖拽结束后的操作
        const dragEndEvent = (dragItem) => {
            setCustomFieldOrderList((prevDataList) => {
                const moveDataList = [...prevDataList];
                const { activeIndex, overIndex } = getMoveIndex(moveDataList, dragItem);
                const newDataList = arrayMove(moveDataList, activeIndex, overIndex);
                return newDataList;
            });
        };

        // 点击checkbox的操作，修改指定ID的对象的isChecked属性取反即可
        const handleCheckedChange = (chosedItemKey) => {
            setCustomFieldOrderList((prevDataList) => {
                const newDataList = [...prevDataList];
                const updatedDataList = newDataList.map((item) => {
                    if (item.key === chosedItemKey) {
                        return { ...item, isChecked: !item.isChecked };
                    }
                    return item;
                });
                return updatedDataList;
            });
        };

        // 拖拽项组件
        const SortableItem = (itemProps) => {
            // 父传子，从props里拿，建议使用其他名字（如itemProps）代替props，以免和父组件的props混淆
            const { checkboxItem } = itemProps;
            const { setNodeRef, attributes, listeners, transform, transition } = useSortable({
                id: checkboxItem.key, // 这里传入的id属性必须和SortableContext的items数组一一对应
                transition: {
                    duration: 500,
                    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
                },
            });
            const liStyles = {
                transform: CSS.Transform.toString(transform),
                transition,
                // disable li symbol
                listStyleType: 'none',
            };
            const textStyles = {
                cursor: 'move',
                userSelect: 'none',
                WebkitUserSelect: 'none',
                MozUserSelect: 'none',
                msUserSelect: 'none',
                minWidth: '100px',
                // align the text to the left
                textAlign: 'left',
            };
            return (
                <li ref={setNodeRef} {...attributes} style={liStyles}>
                    <label className="check-label">
                        <input
                            type="checkbox"
                            name={checkboxItem.key}
                            checked={checkboxItem.isChecked}
                            onChange={() => handleCheckedChange(checkboxItem.key)}
                        />
                        {/*<label className="name-label">{checkboxItem.ptitle || checkboxItem.title}</label>*/}
                        <label className="btn all-scroll" style={textStyles} {...listeners}>{checkboxItem.ptitle || checkboxItem.title}</label>
                        {/* 为Dom添加listeners属性表示设置其为可拖动项 */}
                        {/*<span className="btn all-scroll" {...listeners}>*/}
                        {/*    &#9836;*/}
                        {/*</span>*/}
                    </label>
                </li>
            );
        };

        return (
            <DndContext onDragEnd={dragEndEvent} modifiers={[restrictToParentElement]}>
                <SortableContext items={customFieldOrderList.map((c) => c.key)} strategy={verticalListSortingStrategy}>
                    {/* 这里的items接收一个数组，这个数组的值要和useSortable传入的id属性一一对应 */}
                    <div className="attrs">
                        <ul className="attrs-list">
                            {customFieldOrderList.map((checkboxItem) => (
                                <SortableItem checkboxItem={checkboxItem} key={checkboxItem.key} />
                            ))}
                        </ul>
                    </div>
                </SortableContext>
            </DndContext>
        );
    }


    function ifStringEmptyThenNullify(string) {
        if (string === "") {
            return null;
        }
        return string;
    }

    function ifSameValueThenNullify(newValue, oldValue) {
        if (newValue === oldValue) {
            return null;
        }
        return newValue;
    }

    function ifStringEmptyThenMagicFloat(string) {
        if (string === "") {
            // return C# float.MinValue
            return -3.40282347E+38;
        }
        return string;
    }

    function ifStringEmptyThenMagicInt(string) {
        if (string === "") {
            // return C# int.MinValue
            return -2147483648;
        }
        return string;
    }

    return (
        <Card border="light" className="bg-white shadow-sm mb-4">
            <Card.Body>
                <h5 className="mb-4">
                    { isCreation ? ("新增專案"):("專案資料修改") }
                </h5>
                <Form onSubmit={e => {
                    e.preventDefault();
                    let v_mapPointTextOffsetX = ifStringEmptyThenMagicFloat(e.target.mapPointTextOffsetX.value);
                    let v_mapPointTextOffsetY = ifStringEmptyThenMagicFloat(e.target.mapPointTextOffsetY.value);
                    let v_lineNotifyCooldownMinutes = inheritLineRateLimits ? -2147483648 : Number(projectRateLimits.lineNotifyCooldownMinutes);
                    let v_lineNotifyMaxPerHour = inheritLineRateLimits ? -2147483648 : Number(projectRateLimits.lineNotifyMaxPerHour);
                    let v_lineNotifyMaxPerDay = inheritLineRateLimits ? -2147483648 : Number(projectRateLimits.lineNotifyMaxPerDay);
                    let v_lineNotifyMaxPerMonth = inheritLineRateLimits ? -2147483648 : Number(projectRateLimits.lineNotifyMaxPerMonth);
                    let v_smsNotifyCooldownMinutes = inheritSmsRateLimits ? -2147483648 : Number(projectRateLimits.smsNotifyCooldownMinutes);
                    let v_smsNotifyMaxPerHour = inheritSmsRateLimits ? -2147483648 : Number(projectRateLimits.smsNotifyMaxPerHour);
                    let v_smsNotifyMaxPerDay = inheritSmsRateLimits ? -2147483648 : Number(projectRateLimits.smsNotifyMaxPerDay);
                    let v_smsNotifyMaxPerMonth = inheritSmsRateLimits ? -2147483648 : Number(projectRateLimits.smsNotifyMaxPerMonth);
                    let v_emailNotifyCooldownMinutes = inheritEmailRateLimits ? -2147483648 : Number(projectRateLimits.emailNotifyCooldownMinutes);
                    let v_emailNotifyMaxPerHour = inheritEmailRateLimits ? -2147483648 : Number(projectRateLimits.emailNotifyMaxPerHour);
                    let v_emailNotifyMaxPerDay = inheritEmailRateLimits ? -2147483648 : Number(projectRateLimits.emailNotifyMaxPerDay);
                    let v_emailNotifyMaxPerMonth = inheritEmailRateLimits ? -2147483648 : Number(projectRateLimits.emailNotifyMaxPerMonth);
                    const selectedSmsProvider = smsProvider === "" ? null : Number(smsProvider);
                    const submittedSmsSender = inheritSmsSender ? "" : smsSender.trim();

                    let submittedData = {
                        projectName: isCreation ? e.target.projectName.value : ifSameValueThenNullify(e.target.projectName.value, preData.projectName),
                        projectDescription: isCreation ? e.target.projectDescription.value : ifSameValueThenNullify(e.target.projectDescription.value, preData.projectDescription),
                        databaseName: isCreation ? e.target.databaseName.value : ifSameValueThenNullify(e.target.databaseName.value, preData.databaseName),
                        listEQ_Enabled: isCreation ? e.target.listEQ_Enabled.checked : ifSameValueThenNullify(e.target.listEQ_Enabled.checked, preData.projectListEQ_Enabled),
                        listEQ_DataFolder: isCreation ? refTb_ListEQ_DataFolder.current.value : ifSameValueThenNullify(refTb_ListEQ_DataFolder.current.value, preData.projectListEQ_DataFolder ?? ''),
                        statusTable_Enabled: isCreation ? e.target.statusTable_Enabled.checked : ifSameValueThenNullify(e.target.statusTable_Enabled.checked, preData.projectStatusTable_Enabled),
                        depthSeries_Title: isCreation ? e.target.depthSeries_Title.value : ifSameValueThenNullify(e.target.depthSeries_Title.value, preData.projectDepthSeries_Title),
                        statusDisplayKind: Number(projDisplayKind),
                        statusLogicMode,
                        alertActionStatusDisplayKind: Number(alertActionDisplayKind),
                        customDataFieldOrder: isCreation ? customFieldOrderString : ifSameValueThenNullify(customFieldOrderString, preData.projectCustomDataFieldOrder),
                        mapPointTextBorderColor: isCreation ? e.target.mapPointTextBorderColor.value : ifSameValueThenNullify(e.target.mapPointTextBorderColor.value, preData.projectMapPointTextBorderColor),
                        mapPointTextColor: isCreation ? e.target.mapPointTextColor.value : ifSameValueThenNullify(e.target.mapPointTextColor.value, preData.projectMapPointTextColor),
                        mapPointTextSize: isCreation ? e.target.mapPointTextSize.value : ifSameValueThenNullify(e.target.mapPointTextSize.value, preData.projectMapPointTextSize),
                        mapPointTextOffsetX: isCreation ? v_mapPointTextOffsetX : ifSameValueThenNullify(v_mapPointTextOffsetX, preData.projectMapPointTextOffsetX),
                        mapPointTextOffsetY: isCreation ? v_mapPointTextOffsetY : ifSameValueThenNullify(v_mapPointTextOffsetY, preData.projectMapPointTextOffsetY),
                        isEnableValueNotify: isCreation ? e.target.isEnableValueNotify.checked : ifSameValueThenNullify(e.target.isEnableValueNotify.checked, preData.projectIsEnableValueNotify),
                        isEnableValueNotifyByLine: isCreation ? e.target.isEnableValueNotifyByLine.checked : ifSameValueThenNullify(e.target.isEnableValueNotifyByLine.checked, preData.projectIsEnableValueNotifyByLine),
                        isEnableValueNotifyBySms: isCreation ? e.target.isEnableValueNotifyBySms.checked : ifSameValueThenNullify(e.target.isEnableValueNotifyBySms.checked, preData.projectIsEnableValueNotifyBySms),
                        isEnableValueNotifyByEmail: isCreation ? e.target.isEnableValueNotifyByEmail.checked : ifSameValueThenNullify(e.target.isEnableValueNotifyByEmail.checked, preData.projectIsEnableValueNotifyByEmail),
                        lineNotifyDestination: isCreation ? e.target.lineNotifyDestination.value : ifSameValueThenNullify(e.target.lineNotifyDestination.value, preData.projectLineNotifyDestination),
                        smsProvider: isCreation ? selectedSmsProvider : ifSameValueThenNullify(selectedSmsProvider, preData.projectSmsProvider ?? null),
                        inheritSmsProvider: smsProvider === "",
                        smsSender: isCreation ? submittedSmsSender : ifSameValueThenNullify(submittedSmsSender, preData.projectSmsSender ?? ""),
                        smsRecipients: isCreation ? collectSmsRecipients().join(",") : ifSameValueThenNullify(collectSmsRecipients().join(","), preData.projectSmsRecipients ?? ""),
                        emailRecipients: isCreation ? collectEmailRecipients().join(",") : ifSameValueThenNullify(collectEmailRecipients().join(","), preData.projectEmailRecipients ?? ""),
                        notifyMessageTemplate: isCreation ? e.target.notifyMessageTemplate.value : ifSameValueThenNullify(e.target.notifyMessageTemplate.value, preData.projectNotifyMessageTemplate),
                        lineNotifyCooldownMinutes: isCreation ? v_lineNotifyCooldownMinutes : ifSameValueThenNullify(v_lineNotifyCooldownMinutes, preData.projectLineNotifyCooldownMinutes),
                        lineNotifyMaxPerHour: isCreation ? v_lineNotifyMaxPerHour : ifSameValueThenNullify(v_lineNotifyMaxPerHour, preData.projectLineNotifyMaxPerHour),
                        lineNotifyMaxPerDay: isCreation ? v_lineNotifyMaxPerDay : ifSameValueThenNullify(v_lineNotifyMaxPerDay, preData.projectLineNotifyMaxPerDay),
                        lineNotifyMaxPerMonth: isCreation ? v_lineNotifyMaxPerMonth : ifSameValueThenNullify(v_lineNotifyMaxPerMonth, preData.projectLineNotifyMaxPerMonth),
                        lineNotifyRateLimitProfileId: lineRateLimitProfileId || null,
                        useLineNotifyRateLimitOverride: !inheritLineRateLimits,
                        smsNotifyCooldownMinutes: isCreation ? v_smsNotifyCooldownMinutes : ifSameValueThenNullify(v_smsNotifyCooldownMinutes, preData.projectSmsNotifyCooldownMinutes),
                        smsNotifyMaxPerHour: isCreation ? v_smsNotifyMaxPerHour : ifSameValueThenNullify(v_smsNotifyMaxPerHour, preData.projectSmsNotifyMaxPerHour),
                        smsNotifyMaxPerDay: isCreation ? v_smsNotifyMaxPerDay : ifSameValueThenNullify(v_smsNotifyMaxPerDay, preData.projectSmsNotifyMaxPerDay),
                        smsNotifyMaxPerMonth: isCreation ? v_smsNotifyMaxPerMonth : ifSameValueThenNullify(v_smsNotifyMaxPerMonth, preData.projectSmsNotifyMaxPerMonth),
                        smsNotifyRateLimitProfileId: smsRateLimitProfileId || null,
                        useSmsNotifyRateLimitOverride: !inheritSmsRateLimits,
                        emailNotifyCooldownMinutes: isCreation ? v_emailNotifyCooldownMinutes : ifSameValueThenNullify(v_emailNotifyCooldownMinutes, preData.projectEmailNotifyCooldownMinutes),
                        emailNotifyMaxPerHour: isCreation ? v_emailNotifyMaxPerHour : ifSameValueThenNullify(v_emailNotifyMaxPerHour, preData.projectEmailNotifyMaxPerHour),
                        emailNotifyMaxPerDay: isCreation ? v_emailNotifyMaxPerDay : ifSameValueThenNullify(v_emailNotifyMaxPerDay, preData.projectEmailNotifyMaxPerDay),
                        emailNotifyMaxPerMonth: isCreation ? v_emailNotifyMaxPerMonth : ifSameValueThenNullify(v_emailNotifyMaxPerMonth, preData.projectEmailNotifyMaxPerMonth),
                        emailNotifyRateLimitProfileId: emailRateLimitProfileId || null,
                        useEmailNotifyRateLimitOverride: !inheritEmailRateLimits,
                        lineBotToken: refTb_LineBotToken.current?.value?.trim() || null,
                        lineBotProfileId: lineBotProfileId || null,
                        useExplicitLineBotToken: !lineBotProfileId,
                        createGeoAutoDatabase: isCreation ? (e.target.createGeoAutoDatabase?.checked ?? false) : false,
                        databaseVersion: isCreation ? (e.target.databaseVersion?.value ?? "Status") : null
                    };
                    submitHandler(e, submittedData);
                }}>
                    {!canEdit && (<Row className="mb-3"><Col>非專案管理員，唯讀模式。</Col></Row>)}
                    {!isCreation && (
                        <Row>
                            <Col xs={12} className="mb-3">
                                <Form.Group>
                                    <Form.Label>專案 GUID</Form.Label>
                                    <Form.Control type="text" value={preData?.projectId ?? ''} readOnly />
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label>專案顯示名稱</Form.Label>
                                <Form.Control required={isCreation} name="projectName" type="text" defaultValue={isCreation ? "" : preData?.projectName ?? ''} disabled={!canEdit} />
                            </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label>資料庫鍵</Form.Label>
                                <Form.Control required={isCreation} name="databaseName" type="text" defaultValue={isCreation ? "" : preData?.databaseName ?? ''} disabled={!canEdit}
                                    placeholder="此為影響系統運作的重大鍵值"
                                />
                                {isCreation && isSuperUser && (
                                    <>
                                        <Form.Check type="checkbox" className="mt-2">
                                            <Form.Check.Input id="cb_CreateGeoAutoDatabase" name="createGeoAutoDatabase" defaultChecked={false} />
                                            <Form.Check.Label htmlFor="cb_CreateGeoAutoDatabase">
                                                同時建立 GeoAuto 工地資料庫
                                            </Form.Check.Label>
                                        </Form.Check>
                                        <Form.Group className="mt-2">
                                            <Form.Label>資料庫版本</Form.Label>
                                            <Form.Select name="databaseVersion" defaultValue="Status">
                                                <option value="Status">GeoAuto (Status)</option>
                                                <option value="Status_2023">GeoAuto (Status_2023)</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label>專案說明</Form.Label>
                                <Form.Control type="text" name="projectDescription" as="textarea" rows={3} defaultValue={isCreation ? "" : preData?.projectDescription ?? ''} disabled={!canEdit} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} className="mb-3">
                            <Form.Group>
                                <Form.Label>地震事件設定</Form.Label>
                                <Form.Check type="switch" className="form-check">
                                    <Form.Check.Input type="checkbox" id="cb_ListEQ_Enabled" name="listEQ_Enabled" defaultChecked={isCreation ? false : preData?.projectListEQ_Enabled} disabled={!canEdit} />
                                    <Form.Check.Label htmlFor="cb_ListEQ_Enabled" title="允許使用「地震事件」">
                                        允許使用「地震事件」
                                    </Form.Check.Label>
                                </Form.Check>
                            </Form.Group>
                        </Col>
                        <Col className="mb-3">
                            <Form.Group>
                                <Form.Label>地震事件檔目錄</Form.Label>
                                <Form.Control ref={refTb_ListEQ_DataFolder} type="text" name="listEQ_DataFolder" defaultValue={isCreation ? "" : preData?.projectListEQ_DataFolder} disabled={!canEdit} />
                            </Form.Group>
                        </Col>
                        <Col className="mb-3">
                            <Form.Group>
                                <Form.Label>深度測量標題</Form.Label>
                                <Form.Control type="text" name="depthSeries_Title" defaultValue={isCreation ? "" : preData?.projectDepthSeries_Title} disabled={!canEdit} />
                            </Form.Group>
                        </Col>
                        {/*<Col md='auto' className="mb-3">*/}
                        {/*    <Form.Group>*/}
                        {/*        <Form.Label>_</Form.Label><br/>*/}
                        {/*        <Button onClick={e => {*/}
                        {/*            e.preventDefault();*/}
                        {/*            if (refTb_ListEQ_DataFolder?.current) {*/}
                        {/*                refTb_ListEQ_DataFolder.current.value = "*";*/}
                        {/*            }*/}
                        {/*        }}>使用預設</Button>*/}
                        {/*    </Form.Group>*/}
                        {/*</Col>*/}
                    </Row>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label>即時簡表設定</Form.Label>
                                <Form.Check type="switch" className="form-check">
                                    <Form.Check.Input type="checkbox" id="cb_StatusTable_Enabled" name="statusTable_Enabled" defaultChecked={isCreation ? false : preData?.projectStatusTable_Enabled} disabled={!canEdit} />
                                    <Form.Check.Label htmlFor="cb_StatusTable_Enabled" title="允許使用「即時簡表」">
                                        允許使用「即時簡表」
                                    </Form.Check.Label>
                                </Form.Check>
                            </Form.Group>
                        </Col>
                    </Row>
                    <StatusLightSettings
                        idPrefix={isCreation ? "new-" : ""}
                        mode={statusLogicMode}
                        legacyStyle={projDisplayKind}
                        alertActionStyle={alertActionDisplayKind}
                        onModeChange={setStatusLogicMode}
                        onLegacyStyleChange={setProjDisplayKind}
                        onAlertActionStyleChange={setAlertActionDisplayKind}
                        disabled={!canEdit}
                    />
                    <Row className="mt-4">
                        <Col xs={12}>
                            <Form.Label>地圖格式自訂</Form.Label>
                        </Col>
                        <Col>
                            <Form.Label>邊框色彩編碼</Form.Label>
                            <Form.Control type="text" name="mapPointTextBorderColor" defaultValue={isCreation ? "" : preData?.projectMapPointTextBorderColor} disabled={!canEdit} />
                        </Col>
                        <Col>
                            <Form.Label>文字色彩編碼</Form.Label>
                            <Form.Control type="text" name="mapPointTextColor" defaultValue={isCreation ? "" : preData?.projectMapPointTextColor} disabled={!canEdit} />
                        </Col>
                        <Col>
                            <Form.Label>文字尺寸編碼</Form.Label>
                            <Form.Control type="text" name="mapPointTextSize" defaultValue={isCreation ? "" : preData?.projectMapPointTextSize} disabled={!canEdit} />
                        </Col>
                        <Col>
                            <Form.Label>X偏移量</Form.Label>
                            <Form.Control type="text" name="mapPointTextOffsetX" defaultValue={isCreation ? "" : preData?.projectMapPointTextOffsetX} disabled={!canEdit} />
                        </Col>
                        <Col>
                            <Form.Label>Y偏移量</Form.Label>
                            <Form.Control type="text" name="mapPointTextOffsetY" defaultValue={isCreation ? "" : preData?.projectMapPointTextOffsetY} disabled={!canEdit} />
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col xs={12}>
                            <Form.Label>首頁圖片</Form.Label>
                        </Col>
                        <Col>
                            {isCreation ? (
                                <Alert variant="info">
                                    請先建立專案，再到專案設定上傳首頁圖片。
                                </Alert>
                            ) : (
                                <ProjectDescriptionImageEditor
                                    projectId={preData?.projectId}
                                    existingImageName={preData?.projectDescriptionImage}
                                    canEdit={canEdit}
                                    onImageChanged={onDescriptionImageChanged}
                                />
                            )}
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col>
                            <Form.Label>資料欄位自訂</Form.Label>
                            <DndSortComponent onChange={handleDataListChange} />
                            <Alert variant="info">
                                上下拖曳以調整顯示順序 (由上而下)，勾選以顯示，取消勾選以隱藏。儲存後生效。
                            </Alert>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3" xs={12}>
                            <Form.Label>通知告警</Form.Label>
                            <Alert variant="info">
                                通知告警僅開放比專案管理員更高階的 SuperUser 設定，通常為捷儀人員。
                            </Alert>
                            {isSuperUser && (
                                <Card border="secondary" className="mb-3">
                                    <Card.Body>
                                        <div className="d-flex flex-wrap justify-content-between align-items-center">
                                            <div>
                                                <strong>SQL 全域防濫發設定</strong>
                                                <div className="text-muted small">所有選擇繼承的專案會自動跟隨這組設定。</div>
                                            </div>
                                            <Button type="button" size="sm" variant="outline-secondary" onClick={() => setShowGlobalRateLimitManager(current => !current)}>
                                                {showGlobalRateLimitManager ? "收合全域設定" : "管理全域設定"}
                                            </Button>
                                        </div>
                                        {showGlobalRateLimitManager && (
                                            <div className="mt-3">
                                                {[
                                                    { key: "line", label: "LINE" },
                                                    { key: "sms", label: "GNS SMS" },
                                                    { key: "email", label: "Email" }
                                                ].map(channel => (
                                                    <Row key={channel.key} className="mb-2">
                                                        <Col md={2} className="d-flex align-items-end pb-2"><strong>{channel.label}</strong></Col>
                                                        <Col md={2}>
                                                            <Form.Label>同測點冷卻分鐘</Form.Label>
                                                            <Form.Control type="number" min="1" value={globalRateLimitDraft[`${channel.key}NotifyCooldownMinutes`]} onChange={e => setGlobalRateLimitDraft(current => ({ ...current, [`${channel.key}NotifyCooldownMinutes`]: e.target.value }))} />
                                                        </Col>
                                                        <Col md={2}>
                                                            <Form.Label>每小時上限</Form.Label>
                                                            <Form.Control type="number" min="1" value={globalRateLimitDraft[`${channel.key}NotifyMaxPerHour`]} onChange={e => setGlobalRateLimitDraft(current => ({ ...current, [`${channel.key}NotifyMaxPerHour`]: e.target.value }))} />
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Label>每日上限</Form.Label>
                                                            <Form.Control type="number" min="1" value={globalRateLimitDraft[`${channel.key}NotifyMaxPerDay`]} onChange={e => setGlobalRateLimitDraft(current => ({ ...current, [`${channel.key}NotifyMaxPerDay`]: e.target.value }))} />
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Label>每月上限</Form.Label>
                                                            <Form.Control type="number" min="1" value={globalRateLimitDraft[`${channel.key}NotifyMaxPerMonth`]} onChange={e => setGlobalRateLimitDraft(current => ({ ...current, [`${channel.key}NotifyMaxPerMonth`]: e.target.value }))} />
                                                        </Col>
                                                    </Row>
                                                ))}
                                                <Button type="button" size="sm" onClick={saveGlobalRateLimits} disabled={isSavingGlobalRateLimits}>
                                                    {isSavingGlobalRateLimits ? "儲存中..." : "儲存 SQL 全域設定"}
                                                </Button>
                                                <hr />
                                                <h6>依帳號／業者的防濫發 Profile</h6>
                                                {rateLimitProfiles.map(profile => (
                                                    <div key={profile.id} className="d-flex flex-wrap justify-content-between align-items-center border-bottom py-2">
                                                        <span>
                                                            <strong>{profile.name}</strong> — {profile.channel === 0 ? "LINE" : profile.channel === 1 ? "GNS SMS" : "Email"}；
                                                            {profile.cooldownMinutes} 分鐘／時 {profile.maxPerHour}／日 {profile.maxPerDay}／月 {profile.maxPerMonth}
                                                        </span>
                                                        <span>
                                                            <Button type="button" size="sm" variant="outline-primary" onClick={() => editRateLimitProfile(profile)}>編輯</Button>
                                                            <Button type="button" size="sm" variant="outline-danger" className="ms-2" onClick={() => deleteRateLimitProfile(profile)}>刪除</Button>
                                                        </span>
                                                    </div>
                                                ))}
                                                <Row className="mt-3">
                                                    <Col md={3}>
                                                        <Form.Label>Profile 名稱</Form.Label>
                                                        <Form.Control value={rateLimitProfileDraft.name} onChange={e => setRateLimitProfileDraft(current => ({ ...current, name: e.target.value }))} placeholder="例如 LINE 輕用量" />
                                                    </Col>
                                                    <Col md={2}>
                                                        <Form.Label>通道</Form.Label>
                                                        <Form.Select value={rateLimitProfileDraft.channel} onChange={e => setRateLimitProfileDraft(current => ({ ...current, channel: e.target.value, maxPerMonth: e.target.value === "0" ? 200 : 1000 }))}>
                                                            <option value="0">LINE</option><option value="1">GNS SMS</option><option value="2">Email</option>
                                                        </Form.Select>
                                                    </Col>
                                                    {rateLimitProfileDraft.channel === "0" && (
                                                        <Col md={4}>
                                                            <Form.Label>綁定 LINE Bot（optional）</Form.Label>
                                                            <Form.Select value={rateLimitProfileDraft.lineBotProfileId} onChange={e => setRateLimitProfileDraft(current => ({ ...current, lineBotProfileId: e.target.value }))}>
                                                                <option value="">任何 LINE Bot</option>
                                                                {lineBotProfiles.map(profile => <option key={profile.id} value={profile.id}>{getLineBotProfileLabel(profile)}</option>)}
                                                            </Form.Select>
                                                        </Col>
                                                    )}
                                                    {rateLimitProfileDraft.channel === "1" && (
                                                        <Col md={4}>
                                                            <Form.Label>綁定 GNS 業者（optional）</Form.Label>
                                                            <Form.Select value={rateLimitProfileDraft.smsProvider} onChange={e => setRateLimitProfileDraft(current => ({ ...current, smsProvider: e.target.value }))}>
                                                                <option value="">任何業者</option>
                                                                {SMS_PROVIDERS.map(provider => <option key={provider.value} value={provider.value}>{provider.label}</option>)}
                                                            </Form.Select>
                                                        </Col>
                                                    )}
                                                </Row>
                                                {rateLimitProfileDraft.channel === "0" && (
                                                    <div className="my-2">
                                                        <Button type="button" size="sm" variant="outline-secondary" onClick={() => setRateLimitProfileDraft(current => ({ ...current, name: "LINE 輕用量", maxPerMonth: 200 }))}>套用輕用量 200/月</Button>
                                                        <Button type="button" size="sm" variant="outline-secondary" className="ms-2" onClick={() => setRateLimitProfileDraft(current => ({ ...current, name: "LINE 中用量", maxPerMonth: 3000 }))}>套用中用量 3,000/月</Button>
                                                        <Button type="button" size="sm" variant="outline-secondary" className="ms-2" onClick={() => setRateLimitProfileDraft(current => ({ ...current, name: "LINE 高用量", maxPerMonth: 6000 }))}>套用高用量 6,000/月</Button>
                                                    </div>
                                                )}
                                                <Row>
                                                    {[
                                                        ["cooldownMinutes", "冷卻分鐘"], ["maxPerHour", "每小時"], ["maxPerDay", "每日"], ["maxPerMonth", "每月"]
                                                    ].map(([key, label]) => (
                                                        <Col md={3} key={key}><Form.Label>{label}</Form.Label><Form.Control type="number" min="1" value={rateLimitProfileDraft[key]} onChange={e => setRateLimitProfileDraft(current => ({ ...current, [key]: e.target.value }))} /></Col>
                                                    ))}
                                                </Row>
                                                <div className="mt-2">
                                                    <Button type="button" size="sm" onClick={saveRateLimitProfile} disabled={isSavingRateLimitProfile}>{editingRateLimitProfileId ? "儲存 Profile 修改" : "新增 Profile"}</Button>
                                                    {editingRateLimitProfileId && <Button type="button" size="sm" variant="outline-secondary" className="ms-2" onClick={resetRateLimitProfileDraft}>取消編輯</Button>}
                                                </div>
                                            </div>
                                        )}
                                        {globalRateLimitResult && (
                                            <Alert variant={globalRateLimitResult.variant} className="mt-2 mb-0">{globalRateLimitResult.message}</Alert>
                                        )}
                                    </Card.Body>
                                </Card>
                            )}
                        </Col>
                        <Form.Group>
                            <Form.Check type="switch" className="form-check">
                                <Form.Check.Input type="checkbox" id="cb_ValueNotify_Enabled" name="isEnableValueNotify" defaultChecked={isCreation ? false : preData?.projectIsEnableValueNotify} disabled={!canEdit || !isSuperUser} />
                                <Form.Check.Label htmlFor="cb_ValueNotify_Enabled" title="允許通知告警">
                                    允許通知告警
                                </Form.Check.Label>
                            </Form.Check>
                        </Form.Group>
                        <Form.Group>
                            <Form.Check type="switch" className="form-check">
                                <Form.Check.Input type="checkbox" id="cb_ValueNotifyBySms_Enabled" name="isEnableValueNotifyBySms" defaultChecked={isCreation ? false : preData?.projectIsEnableValueNotifyBySms} disabled={!canEdit || !isSuperUser} />
                                <Form.Check.Label htmlFor="cb_ValueNotifyBySms_Enabled" title="啟動 GNS 簡訊通知告警">
                                    啟動 GNS 簡訊通知告警
                                </Form.Check.Label>
                            </Form.Check>
                        </Form.Group>
                        <Col md={6}>
                            <Form.Label>GNS 簡訊供應商</Form.Label>
                            <Form.Select
                                name="smsProvider"
                                value={smsProvider}
                                onChange={e => setSmsProvider(e.target.value)}
                                disabled={!canEdit || !isSuperUser}
                            >
                                <option value="">
                                    繼承全域（目前：{globalSmsDefaults.defaultSmsProviderName ?? "Infobip"}）
                                </option>
                                {SMS_PROVIDERS.map(provider => (
                                    <option key={provider.value} value={provider.value}>{provider.label}</option>
                                ))}
                            </Form.Select>
                            <Form.Text className="text-muted">
                                實際使用：{effectiveSmsProviderInfo.label}。全域預設變更後，繼承的專案會自動跟隨。
                            </Form.Text>
                        </Col>
                        <Col md={6}>
                            <Form.Label>簡訊發送號碼／發送人</Form.Label>
                            <Form.Check
                                type="switch"
                                id="cb_InheritSmsSender"
                                label={`繼承 ${effectiveSmsProviderInfo.label} 全域設定（目前：${globalSmsSender || "未設定"}）`}
                                checked={inheritSmsSender}
                                onChange={e => setInheritSmsSender(e.target.checked)}
                                disabled={!canEdit || !isSuperUser}
                                className="mb-2"
                            />
                            <Form.Control
                                type="text"
                                name="smsSender"
                                value={smsSender}
                                onChange={e => setSmsSender(e.target.value)}
                                disabled={!canEdit || !isSuperUser || inheritSmsSender}
                                placeholder={inheritSmsSender ? (globalSmsSender || "全域尚未設定") : "輸入此專案的覆寫值"}
                            />
                            <Form.Text className="text-muted">
                                實際使用：{effectiveSmsSender || "未設定"}。全域發送號碼依業者分開保存；目前 GNS 僅 Infobip 送出 from 欄位。
                            </Form.Text>
                        </Col>
                        {smsDefaultsError && (
                            <Col md={12} className="mt-2">
                                <Alert variant="warning" className="mb-0">
                                    全域 GNS 設定讀取失敗：{smsDefaultsError}。後端發送時仍會解析最新全域設定。
                                </Alert>
                            </Col>
                        )}
                        <Col md={12}>
                            <Form.Label>簡訊收訊號碼（可多筆）</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    value={newSmsRecipient}
                                    onChange={e => setNewSmsRecipient(e.target.value)}
                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            addSmsRecipient();
                                        }
                                    }}
                                    placeholder="例如 886912345678"
                                    disabled={!canEdit || !isSuperUser}
                                />
                                <Button type="button" variant="outline-secondary" onClick={addSmsRecipient} disabled={!canEdit || !isSuperUser || !newSmsRecipient.trim()}>
                                    加入
                                </Button>
                            </InputGroup>
                            <div className="mt-2">
                                {smsRecipients.map(recipient => (
                                    <Button
                                        key={recipient}
                                        type="button"
                                        size="sm"
                                        variant="outline-dark"
                                        className="me-2 mb-2"
                                        onClick={() => removeSmsRecipient(recipient)}
                                        disabled={!canEdit || !isSuperUser}
                                        title="點擊移除"
                                    >
                                        {recipient} ×
                                    </Button>
                                ))}
                                {smsRecipients.length === 0 && (
                                    <Form.Text className="text-muted">尚未加入收訊號碼。</Form.Text>
                                )}
                            </div>
                        </Col>
                        <Col md={12} className="mt-2">
                            <Form.Label>SMS 防濫發限制來源</Form.Label>
                            <Form.Select value={smsRateLimitProfileId || (inheritSmsRateLimits ? "global" : "override")} onChange={e => setRateLimitSource("sms", e.target.value)} disabled={!canEdit || !isSuperUser}>
                                <option value="global">繼承 SQL 全域基準（{globalRateLimits.smsNotifyCooldownMinutes} 分鐘／時 {globalRateLimits.smsNotifyMaxPerHour}／日 {globalRateLimits.smsNotifyMaxPerDay}／月 {globalRateLimits.smsNotifyMaxPerMonth}）</option>
                                {rateLimitProfiles.filter(profile => profile.channel === 1 && (profile.smsProvider == null || String(profile.smsProvider) === effectiveSmsProvider)).map(profile => <option key={profile.id} value={profile.id}>Profile：{profile.name}（{profile.cooldownMinutes} 分鐘／時 {profile.maxPerHour}／日 {profile.maxPerDay}／月 {profile.maxPerMonth}）</option>)}
                                <option value="override">此專案自行覆寫</option>
                            </Form.Select>
                        </Col>
                        <Col md={3} className="mt-2">
                            <Form.Label>SMS 同測點冷卻分鐘</Form.Label>
                            <Form.Control type="number" min="1" required={!inheritSmsRateLimits} name="smsNotifyCooldownMinutes" value={projectRateLimits.smsNotifyCooldownMinutes} onChange={e => setProjectRateLimit("smsNotifyCooldownMinutes", e.target.value)} placeholder={`全域 ${globalRateLimits.smsNotifyCooldownMinutes}`} disabled={!canEdit || !isSuperUser || inheritSmsRateLimits} />
                        </Col>
                        <Col md={3} className="mt-2">
                            <Form.Label>SMS 每小時發送上限</Form.Label>
                            <Form.Control type="number" min="1" required={!inheritSmsRateLimits} name="smsNotifyMaxPerHour" value={projectRateLimits.smsNotifyMaxPerHour} onChange={e => setProjectRateLimit("smsNotifyMaxPerHour", e.target.value)} placeholder={`全域 ${globalRateLimits.smsNotifyMaxPerHour}`} disabled={!canEdit || !isSuperUser || inheritSmsRateLimits} />
                        </Col>
                        <Col md={3} className="mt-2">
                            <Form.Label>SMS 每日發送上限</Form.Label>
                            <Form.Control type="number" min="1" required={!inheritSmsRateLimits} name="smsNotifyMaxPerDay" value={projectRateLimits.smsNotifyMaxPerDay} onChange={e => setProjectRateLimit("smsNotifyMaxPerDay", e.target.value)} placeholder={`全域 ${globalRateLimits.smsNotifyMaxPerDay}`} disabled={!canEdit || !isSuperUser || inheritSmsRateLimits} />
                        </Col>
                        <Col md={3} className="mt-2">
                            <Form.Label>SMS 每月發送上限</Form.Label>
                            <Form.Control type="number" min="1" required={!inheritSmsRateLimits} name="smsNotifyMaxPerMonth" value={projectRateLimits.smsNotifyMaxPerMonth} onChange={e => setProjectRateLimit("smsNotifyMaxPerMonth", e.target.value)} placeholder={`全域 ${globalRateLimits.smsNotifyMaxPerMonth}`} disabled={!canEdit || !isSuperUser || inheritSmsRateLimits} />
                            <Form.Text className="text-muted">按收訊號碼數計算；每小時／每日含失敗嘗試，每月只計成功發送。</Form.Text>
                        </Col>
                        <Form.Group className="mt-3">
                            <Form.Check type="switch" className="form-check">
                                <Form.Check.Input type="checkbox" id="cb_ValueNotifyByEmail_Enabled" name="isEnableValueNotifyByEmail" defaultChecked={isCreation ? false : preData?.projectIsEnableValueNotifyByEmail} disabled={!canEdit || !isSuperUser} />
                                <Form.Check.Label htmlFor="cb_ValueNotifyByEmail_Enabled" title="啟動 SMTP Email 通知告警">
                                    啟動 Email 通知告警
                                </Form.Check.Label>
                            </Form.Check>
                        </Form.Group>
                        <Col md={12}>
                            <Form.Label>Email 收件人（可多筆）</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="email"
                                    value={newEmailRecipient}
                                    onChange={e => setNewEmailRecipient(e.target.value)}
                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            addEmailRecipient();
                                        }
                                    }}
                                    placeholder="例如 alert@example.com"
                                    disabled={!canEdit || !isSuperUser}
                                />
                                <Button type="button" variant="outline-secondary" onClick={addEmailRecipient} disabled={!canEdit || !isSuperUser || !newEmailRecipient.trim()}>
                                    加入
                                </Button>
                            </InputGroup>
                            <div className="mt-2">
                                {emailRecipients.map(recipient => (
                                    <Button
                                        key={recipient}
                                        type="button"
                                        size="sm"
                                        variant="outline-dark"
                                        className="me-2 mb-2"
                                        onClick={() => removeEmailRecipient(recipient)}
                                        disabled={!canEdit || !isSuperUser}
                                        title="點擊移除"
                                    >
                                        {recipient} ×
                                    </Button>
                                ))}
                                {emailRecipients.length === 0 && (
                                    <Form.Text className="text-muted">尚未加入 Email 收件人。</Form.Text>
                                )}
                            </div>
                            {globalEmailDefaults && (
                                <Alert variant={globalEmailDefaults.enabled ? "info" : "warning"} className="mt-2 mb-0">
                                    全域 SMTP：{globalEmailDefaults.enabled ? "已啟用" : "未啟用"}；
                                    寄件人：{globalEmailDefaults.fromName || "未設定"} &lt;{globalEmailDefaults.fromAddress || "未設定"}&gt;；
                                    伺服器：{globalEmailDefaults.host || "未設定"}:{globalEmailDefaults.port}；
                                    SSL：{globalEmailDefaults.enableSsl ? "是" : "否"}
                                </Alert>
                            )}
                            {emailDefaultsError && (
                                <Alert variant="warning" className="mt-2 mb-0">
                                    全域 SMTP 設定讀取失敗：{emailDefaultsError}
                                </Alert>
                            )}
                            <Row className="mt-2">
                                <Col md={12}>
                                    <Form.Label>Email 防濫發限制來源</Form.Label>
                                    <Form.Select value={emailRateLimitProfileId || (inheritEmailRateLimits ? "global" : "override")} onChange={e => setRateLimitSource("email", e.target.value)} disabled={!canEdit || !isSuperUser}>
                                        <option value="global">繼承 SQL 全域基準（{globalRateLimits.emailNotifyCooldownMinutes} 分鐘／時 {globalRateLimits.emailNotifyMaxPerHour}／日 {globalRateLimits.emailNotifyMaxPerDay}／月 {globalRateLimits.emailNotifyMaxPerMonth}）</option>
                                        {rateLimitProfiles.filter(profile => profile.channel === 2).map(profile => <option key={profile.id} value={profile.id}>Profile：{profile.name}（{profile.cooldownMinutes} 分鐘／時 {profile.maxPerHour}／日 {profile.maxPerDay}／月 {profile.maxPerMonth}）</option>)}
                                        <option value="override">此專案自行覆寫</option>
                                    </Form.Select>
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Email 同測點冷卻分鐘</Form.Label>
                                    <Form.Control type="number" min="1" required={!inheritEmailRateLimits} name="emailNotifyCooldownMinutes" value={projectRateLimits.emailNotifyCooldownMinutes} onChange={e => setProjectRateLimit("emailNotifyCooldownMinutes", e.target.value)} placeholder={`全域 ${globalRateLimits.emailNotifyCooldownMinutes}`} disabled={!canEdit || !isSuperUser || inheritEmailRateLimits} />
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Email 每小時發送上限</Form.Label>
                                    <Form.Control type="number" min="1" required={!inheritEmailRateLimits} name="emailNotifyMaxPerHour" value={projectRateLimits.emailNotifyMaxPerHour} onChange={e => setProjectRateLimit("emailNotifyMaxPerHour", e.target.value)} placeholder={`全域 ${globalRateLimits.emailNotifyMaxPerHour}`} disabled={!canEdit || !isSuperUser || inheritEmailRateLimits} />
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Email 每日發送上限</Form.Label>
                                    <Form.Control type="number" min="1" required={!inheritEmailRateLimits} name="emailNotifyMaxPerDay" value={projectRateLimits.emailNotifyMaxPerDay} onChange={e => setProjectRateLimit("emailNotifyMaxPerDay", e.target.value)} placeholder={`全域 ${globalRateLimits.emailNotifyMaxPerDay}`} disabled={!canEdit || !isSuperUser || inheritEmailRateLimits} />
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Email 每月發送上限</Form.Label>
                                    <Form.Control type="number" min="1" required={!inheritEmailRateLimits} name="emailNotifyMaxPerMonth" value={projectRateLimits.emailNotifyMaxPerMonth} onChange={e => setProjectRateLimit("emailNotifyMaxPerMonth", e.target.value)} placeholder={`全域 ${globalRateLimits.emailNotifyMaxPerMonth}`} disabled={!canEdit || !isSuperUser || inheritEmailRateLimits} />
                                    <Form.Text className="text-muted">按收件人數計算；每小時／每日含失敗嘗試，每月只計成功寄送。</Form.Text>
                                </Col>
                            </Row>
                            {!isCreation && isSuperUser && canEdit && (
                                <div className="mt-2">
                                    <Button
                                        type="button"
                                        variant="outline-primary"
                                        onClick={testEmailMessage}
                                        disabled={isTestingEmail}
                                    >
                                        {isTestingEmail ? "測試寄送中..." : "測試寄送 Email"}
                                    </Button>
                                    <Form.Text className="ms-2 text-muted">
                                        使用目前畫面的全部 Email 收件人，不會自動儲存。
                                    </Form.Text>
                                    {emailTestResult && (
                                        <Alert variant={emailTestResult.variant} className="mt-2 mb-0">
                                            <div>{emailTestResult.message}</div>
                                            {emailTestResult.details && (
                                                <>
                                                    <Button
                                                        type="button"
                                                        size="sm"
                                                        variant="outline-dark"
                                                        className="mt-2"
                                                        onClick={() => setEmailTestResult(current => ({ ...current, showDetails: !current.showDetails }))}
                                                    >
                                                        {emailTestResult.showDetails ? "隱藏完整 Response" : "查看完整 Response"}
                                                    </Button>
                                                    {emailTestResult.showDetails && (
                                                        <pre className="mt-2 mb-0 p-2 bg-light border rounded overflow-auto" style={{ maxHeight: "420px", whiteSpace: "pre-wrap" }}>
                                                            {JSON.stringify(emailTestResult.details, null, 2)}
                                                        </pre>
                                                    )}
                                                </>
                                            )}
                                        </Alert>
                                    )}
                                </div>
                            )}
                        </Col>
                        <Form.Group>
                            <Form.Check type="switch" className="form-check">
                                <Form.Check.Input type="checkbox" id="cb_ValueNotifyByLine_Enabled" name="isEnableValueNotifyByLine" defaultChecked={isCreation ? false : preData?.projectIsEnableValueNotifyByLine} disabled={!canEdit || !isSuperUser} />
                                <Form.Check.Label htmlFor="cb_ValueNotifyByLine_Enabled" title="允許通知告警">
                                    啟動 Line 通知告警
                                </Form.Check.Label>
                            </Form.Check>
                        </Form.Group>
                        <Col>
                            <Form.Label>Line 通知目標 ID</Form.Label>
                            <Form.Control ref={refTb_LineNotifyDestination} type="text" name="lineNotifyDestination" defaultValue={isCreation ? "" : preData?.projectLineNotifyDestination} disabled={!canEdit || !isSuperUser} />
                        </Col>
                        <Col md={6}>
                            <Form.Label>LINE Bot Token 來源</Form.Label>
                            <Form.Select
                                value={lineBotProfileId}
                                onChange={e => setLineBotProfileId(e.target.value)}
                                disabled={!canEdit || !isSuperUser}
                            >
                                <option value="">專案直接輸入（相容舊設定）</option>
                                {lineBotProfileId && !lineBotProfiles.some(profile => profile.id === lineBotProfileId) && (
                                    <option value={lineBotProfileId}>目前設定檔不存在或尚未載入</option>
                                )}
                                {lineBotProfiles.map(profile => (
                                    <option key={profile.id} value={profile.id}>
                                        {getLineBotProfileLabel(profile)}{profile.hasAccessToken ? "" : "（Token 未設定）"}
                                    </option>
                                ))}
                            </Form.Select>
                            <Button
                                type="button"
                                size="sm"
                                variant="outline-secondary"
                                className="mt-2"
                                onClick={() => setShowLineBotProfileManager(current => !current)}
                                disabled={!isSuperUser}
                            >
                                {showLineBotProfileManager ? "收合設定檔管理" : "管理 LINE Bot 設定檔"}
                            </Button>
                        </Col>
                        <Col md={6}>
                            <Form.Label>專案直接輸入 Access Token</Form.Label>
                            <Form.Control
                                ref={refTb_LineBotToken}
                                type="password"
                                name="lineBotToken"
                                defaultValue=""
                                placeholder={!isCreation && preData?.projectHasLineBotToken ? "已設定；留空可保留目前 Token" : "請輸入 Channel Access Token"}
                                autoComplete="new-password"
                                disabled={!canEdit || !isSuperUser || !!lineBotProfileId}
                            />
                            <Form.Text className="text-muted">
                                {lineBotProfileId
                                    ? "目前使用 SQL 設定檔；原本的專案 Token 會保留，切回直接輸入時仍可使用。"
                                    : "Token 不會由後端回傳；編輯既有專案時留空即可保留原設定。"}
                            </Form.Text>
                        </Col>
                        {showLineBotProfileManager && isSuperUser && (
                            <Col md={12} className="mt-3">
                                <Card border="light" className="bg-light">
                                    <Card.Body>
                                        <h6>LINE Bot 設定檔管理（僅 SuperUser）</h6>
                                        {lineBotProfiles.length === 0 && (
                                            <Form.Text className="text-muted">目前沒有 LINE Bot 設定檔。</Form.Text>
                                        )}
                                        {lineBotProfiles.map(profile => (
                                            <div key={profile.id} className="d-flex flex-wrap align-items-center justify-content-between border-bottom py-2">
                                                <div>
                                                    <div>{getLineBotProfileLabel(profile)}</div>
                                                    <small className="text-muted">
                                                        Access Token：{profile.hasAccessToken ? "已設定" : "未設定"}
                                                    </small>
                                                </div>
                                                <div>
                                                    <Button type="button" size="sm" variant="outline-primary" onClick={() => editLineBotProfile(profile)}>
                                                        編輯
                                                    </Button>
                                                    <Button type="button" size="sm" variant="outline-danger" className="ms-2" onClick={() => deleteLineBotProfile(profile)}>
                                                        刪除
                                                    </Button>
                                                </div>
                                            </div>
                                        ))}
                                        <Row className="mt-3">
                                            <Col md={4}>
                                                <Form.Label>辨識名稱（optional）</Form.Label>
                                                <Form.Control value={lineBotProfileName} onChange={e => setLineBotProfileName(e.target.value)} placeholder="例如：GeoNow 正式 Bot" />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label>綁定電話號碼（optional）</Form.Label>
                                                <Form.Control value={lineBotProfilePhone} onChange={e => setLineBotProfilePhone(e.target.value)} placeholder="例如：0912345678" />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Label>Channel Access Token</Form.Label>
                                                <Form.Control
                                                    type="password"
                                                    value={lineBotProfileToken}
                                                    onChange={e => setLineBotProfileToken(e.target.value)}
                                                    placeholder={editingLineBotProfileId ? "留空可保留目前 Token" : "新設定檔必填"}
                                                    autoComplete="new-password"
                                                />
                                            </Col>
                                        </Row>
                                        <div className="mt-3">
                                            <Button type="button" size="sm" onClick={saveLineBotProfile} disabled={isSavingLineBotProfile || (!editingLineBotProfileId && !lineBotProfileToken.trim())}>
                                                {isSavingLineBotProfile ? "儲存中..." : editingLineBotProfileId ? "儲存修改" : "建立設定檔"}
                                            </Button>
                                            {editingLineBotProfileId && (
                                                <Button type="button" size="sm" variant="outline-secondary" className="ms-2" onClick={resetLineBotProfileEditor} disabled={isSavingLineBotProfile}>
                                                    取消編輯
                                                </Button>
                                            )}
                                        </div>
                                        {lineBotProfileResult && (
                                            <Alert variant={lineBotProfileResult.variant} className="mt-2 mb-0">
                                                {lineBotProfileResult.message}
                                            </Alert>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                        )}
                        <Col md={12}>
                            <Form.Label>LINE 防濫發限制來源</Form.Label>
                            <Form.Select value={lineRateLimitProfileId || (inheritLineRateLimits ? "global" : "override")} onChange={e => setRateLimitSource("line", e.target.value)} disabled={!canEdit || !isSuperUser}>
                                <option value="global">繼承 SQL 全域基準（{globalRateLimits.lineNotifyCooldownMinutes} 分鐘／時 {globalRateLimits.lineNotifyMaxPerHour}／日 {globalRateLimits.lineNotifyMaxPerDay}／月 {globalRateLimits.lineNotifyMaxPerMonth}）</option>
                                {rateLimitProfiles.filter(profile => profile.channel === 0 && (profile.lineBotProfileId == null || profile.lineBotProfileId === lineBotProfileId)).map(profile => <option key={profile.id} value={profile.id}>Profile：{profile.name}（{profile.cooldownMinutes} 分鐘／時 {profile.maxPerHour}／日 {profile.maxPerDay}／月 {profile.maxPerMonth}）</option>)}
                                <option value="override">此專案自行覆寫</option>
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label>LINE 同測點冷卻分鐘</Form.Label>
                            <Form.Control type="number" min="1" required={!inheritLineRateLimits} name="lineNotifyCooldownMinutes" value={projectRateLimits.lineNotifyCooldownMinutes} onChange={e => setProjectRateLimit("lineNotifyCooldownMinutes", e.target.value)} placeholder={`全域 ${globalRateLimits.lineNotifyCooldownMinutes}`} disabled={!canEdit || !isSuperUser || inheritLineRateLimits} />
                        </Col>
                        <Col md={3}>
                            <Form.Label>LINE 每小時發送上限</Form.Label>
                            <Form.Control type="number" min="1" required={!inheritLineRateLimits} name="lineNotifyMaxPerHour" value={projectRateLimits.lineNotifyMaxPerHour} onChange={e => setProjectRateLimit("lineNotifyMaxPerHour", e.target.value)} placeholder={`全域 ${globalRateLimits.lineNotifyMaxPerHour}`} disabled={!canEdit || !isSuperUser || inheritLineRateLimits} />
                        </Col>
                        <Col md={3}>
                            <Form.Label>LINE 每日發送上限</Form.Label>
                            <Form.Control type="number" min="1" required={!inheritLineRateLimits} name="lineNotifyMaxPerDay" value={projectRateLimits.lineNotifyMaxPerDay} onChange={e => setProjectRateLimit("lineNotifyMaxPerDay", e.target.value)} placeholder={`全域 ${globalRateLimits.lineNotifyMaxPerDay}`} disabled={!canEdit || !isSuperUser || inheritLineRateLimits} />
                        </Col>
                        <Col md={3}>
                            <Form.Label>LINE 每月發送上限</Form.Label>
                            <Form.Control type="number" min="1" required={!inheritLineRateLimits} name="lineNotifyMaxPerMonth" value={projectRateLimits.lineNotifyMaxPerMonth} onChange={e => setProjectRateLimit("lineNotifyMaxPerMonth", e.target.value)} placeholder={`全域 ${globalRateLimits.lineNotifyMaxPerMonth}`} disabled={!canEdit || !isSuperUser || inheritLineRateLimits} />
                            <Form.Text className="text-muted">按目的地數計算；每小時／每日含失敗嘗試，每月只計成功推播。</Form.Text>
                        </Col>
                        <Col md={12}>
                            <Form.Label>告警訊息自訂範本</Form.Label>
                            <Form.Control as="textarea" rows="3" type="text" name="notifyMessageTemplate" defaultValue={isCreation ? "" : preData?.projectNotifyMessageTemplate} disabled={!canEdit || !isSuperUser} />
                        </Col>
                        {!isCreation && isSuperUser && canEdit && (
                            <Col md={12} className="mt-3">
                                <Button
                                    type="button"
                                    variant="outline-primary"
                                    onClick={testLineMessage}
                                    disabled={isTestingLine}
                                >
                                    {isTestingLine ? "測試發送中..." : "測試發送 LINE 訊息"}
                                </Button>
                                <Form.Text className="ms-2 text-muted">
                                    使用目前畫面中的目標 ID 與 Token；留空 Token 會使用已儲存設定。
                                </Form.Text>
                                {lineTestResult && (
                                    <Alert variant={lineTestResult.variant} className="mt-2 mb-0">
                                        {lineTestResult.message}
                                    </Alert>
                                )}
                            </Col>
                        )}
                        {!isCreation && isSuperUser && canEdit && (
                            <Col md={12} className="mt-3">
                                <Button
                                    type="button"
                                    variant="outline-primary"
                                    onClick={testSmsMessage}
                                    disabled={isTestingSms}
                                >
                                    {isTestingSms ? "測試發送中..." : "測試發送 GNS 簡訊"}
                                </Button>
                                <Button
                                    type="button"
                                    variant="outline-secondary"
                                    className="ms-2"
                                    onClick={querySmsBalance}
                                    disabled={isQueryingSmsBalance}
                                >
                                    {isQueryingSmsBalance ? "查詢中..." : "查詢簡訊餘額"}
                                </Button>
                                <Form.Text className="ms-2 text-muted">
                                    測試發送使用目前選擇的供應商與全部收訊號碼，不會自動儲存。
                                </Form.Text>
                                {smsTestResult && (
                                    <Alert variant={smsTestResult.variant} className="mt-2 mb-0">
                                        <div>{smsTestResult.message}</div>
                                        {smsTestResult.details && (
                                            <>
                                                <Button
                                                    type="button"
                                                    size="sm"
                                                    variant="outline-dark"
                                                    className="mt-2"
                                                    onClick={() => setSmsTestResult(current => ({ ...current, showDetails: !current.showDetails }))}
                                                >
                                                    {smsTestResult.showDetails ? "隱藏完整 Response" : "查看完整 Response"}
                                                </Button>
                                                {smsTestResult.showDetails && (
                                                    <pre className="mt-2 mb-0 p-2 bg-light border rounded overflow-auto" style={{ maxHeight: "420px", whiteSpace: "pre-wrap" }}>
                                                        {JSON.stringify(smsTestResult.details, null, 2)}
                                                    </pre>
                                                )}
                                            </>
                                        )}
                                    </Alert>
                                )}
                                {smsBalanceResult && (
                                    <Alert variant={smsBalanceResult.variant} className="mt-2 mb-0">
                                        <div>{smsBalanceResult.message}</div>
                                        {smsBalanceResult.details && (
                                            <>
                                                <Button
                                                    type="button"
                                                    size="sm"
                                                    variant="outline-dark"
                                                    className="mt-2"
                                                    onClick={() => setSmsBalanceResult(current => ({ ...current, showDetails: !current.showDetails }))}
                                                >
                                                    {smsBalanceResult.showDetails ? "隱藏完整 Response" : "查看完整 Response"}
                                                </Button>
                                                {smsBalanceResult.showDetails && (
                                                    <pre className="mt-2 mb-0 p-2 bg-light border rounded overflow-auto" style={{ maxHeight: "420px", whiteSpace: "pre-wrap" }}>
                                                        {JSON.stringify(smsBalanceResult.details, null, 2)}
                                                    </pre>
                                                )}
                                            </>
                                        )}
                                    </Alert>
                                )}
                            </Col>
                        )}
                    </Row>

                    {/*<Row>*/}
                    {/*    {isCreation && (*/}
                    {/*        <>*/}
                    {/*            創建模式*/}
                    {/*        </>*/}
                    {/*    )}*/}
                    {/*    {!isCreation && (*/}
                    {/*        <>*/}
                    {/*            編輯模式*/}
                    {/*        </>*/}
                    {/*    )}*/}
                    {/*</Row>*/}
                    <div className="mt-3">
                        {canEdit && (
                            <Button variant="primary" type="submit">
                                {isCreation ? "新增" : "更改"}
                            </Button>
                        )
                        }
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
};
